<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" @click="close">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle"></header>
        <section class="modal-body" id="modalDescription">
          <div class="video-player-wrapper" ref="videoPlayerWrapperRef">
            <!-- <div class="close-icon-wrapper">
              <span class="material-icons close-icon" @click="close">
                close
              </span>
            </div> -->
            <cld-video
              v-if="video.VideoType == 'cloudinary'"
              cloudName="avd"
              :publicId="video.PublicId"
              :version="video.Version"
              tabindex="-1"
              controls
              width="600"
              height="374"
              autoplay
              preload="metadata"
              data-cld-colors='{ "base": "#0071ba", "accent": "#db8226", "text": "#fff" }'
            >
            </cld-video>
            <youtube
              :video-id="video.VideoId"
              v-if="video.VideoType == 'youtube'"
              autoplay
              controls="true"
              :player-vars="playerVars"
            ></youtube>

            <vimeo-player
              v-if="video.VideoType === 'vimeo'"
              :video-id="video.VideoId"
              :data-vimeo-url="video.videoUrl"
              controls="true"
              autoplay="true"
            >
            </vimeo-player>
          </div>
        </section>
        <footer class="modal-footer"></footer>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductDesktopVideosModal",
  props: {
    video: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      playerVars: {
        autoplay: 1,
        rel: 0
      }
    };
  },
  created() {
    const onEscape = e => {
      if (e.keyCode === 27) {
        this.$emit("close");
      }
    };
    document.addEventListener("keydown", onEscape);
    this.$once("hook:destroyed", () => {
      document.removeEventListener("keydown", onEscape);
    });
  },
  methods: {
    close(e) {
      let playerWrapperPos = this.$refs.videoPlayerWrapperRef.getBoundingClientRect();
      if (
        e.clientX > playerWrapperPos.x &&
        e.clientX < playerWrapperPos.right &&
        e.clientY > playerWrapperPos.y &&
        e.clientY < playerWrapperPos.bottom
      ) {
        return;
      }
      this.$emit("close");
    }
  },
  components: {},
  mounted() {},
  computed: {
    ...mapGetters("product", ["getZoomerImages"])
  }
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
  height: 46px;
  align-items: center;
}

.modal-footer {
  justify-content: center;
}

.modal-body {
  position: relative;
  height: 100%;
}

.btn-close {
  border: none;
  cursor: pointer;
  background: transparent;
  color: rgb(60, 95, 104);
  font-size: 16px;
  font-family: $font-weight-normal;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  line-height: 24px;
  height: 22px;
  padding-left: 0px;
}

.video-player-wrapper {
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
}

.close-icon {
  color: #fff;
  z-index: 10;
  position: absolute;
  right: 0;
  cursor: pointer;
}

.close-icon-wrapper {
  position: relative;
  height: 15px;
}
</style>
